import { useQuery } from '@tanstack/react-query';
import type { CustomerSearch, CustomerSearchResponse } from '@metron/shared';
import { toCustomerSearchParams } from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

/**
 * Runs a Smart Search customer spec against `GET /customers/filter` (MET-3525).
 * Same caching and previous-page behavior as `useMeterFilter`.
 */
export function useCustomerFilter(spec: CustomerSearch | null) {
  const apiClient = useApiClient();
  const params = spec ? toCustomerSearchParams(spec).toString() : '';

  return useQuery({
    queryKey: ['customer-filter', params],
    queryFn: () => apiClient.get<CustomerSearchResponse>(`customers/filter?${params}`),
    enabled: spec !== null,
    placeholderData: (previous) => previous,
  });
}
